import React from 'react';
const steps = ['Open', 'Print', 'Teach'];
export function SolutionSection() {
  return <section className="w-full bg-blush py-10 sm:py-12" aria-labelledby="solution-heading" data-id="element-186" data-mp="3aa13kaikcdv6">
      <div className="mx-auto max-w-4xl px-6" data-id="element-187" data-mp="3o9kbp3bdjp7h">
        <div className="rounded-4xl border border-gold/35 bg-cream px-7 py-11 text-center shadow-soft sm:px-14" data-id="element-188" data-mp="3o77jlxbwjygp">
          <p className="flex items-center justify-center gap-4 font-display text-lg italic text-goldink" data-id="element-189" data-mp="3jck2wkn548co">
            <span className="h-px w-10 bg-gold/50" aria-hidden="true" data-id="element-190" data-mp="3t8df22wy5ztx" />
            Introducing
            <span className="h-px w-10 bg-gold/50" aria-hidden="true" data-id="element-191" data-mp="aue8q4u338od" />
          </p>

          <h2 id="solution-heading" className="mx-auto mt-4 max-w-2xl font-display text-4xl leading-[1.1] text-charcoal sm:text-5xl" data-id="element-192" data-mp="awi7k8d4lhhs">
            Ballet Teacher Elite System
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-display text-2xl italic leading-snug text-wine" data-id="element-193" data-mp="ftqtmk1ea5ob">
            A complete teaching system that puts structure behind your
            expertise.
          </p>

          <p className="mx-auto mt-7 max-w-readable font-sans text-base leading-relaxed text-ash" data-id="element-194" data-mp="3b970tbwe8znn">
            Not a folder of loose exercises. A{' '}
            <span className="font-medium text-wine" data-id="element-195" data-mp="3f9zcscwnhinm">
              Professional Master Library
            </span>{' '}
            already sorted by technical objective and level — nothing to
            rewrite, nothing to pause and transcribe.
          </p>

          <ul className="mt-8 flex items-center justify-center gap-3 sm:gap-5" data-id="element-196" data-mp="3u7rosv2znox2">
            {steps.map((step, index) => <li key={step} className="flex items-center gap-3 sm:gap-5" data-id="element-197" data-mp="2uf9s6jtsd7u" data-mpi={index}>
                <span className="font-display text-2xl text-charcoal sm:text-3xl" data-id="element-198" data-mp="6vqt5uc3w27l">
                  {step}
                </span>
                {index < steps.length - 1 ? <span className="h-1.5 w-1.5 rounded-full bg-rose-deep" aria-hidden="true" data-id="element-199" data-mp="gteux484q9z9" /> : null}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}